
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplatesGrid extends Serenity.EntityGrid<WhatsAppTemplatesRow, any> {
        protected getColumnsKey() { return WhatsAppTemplatesColumns.columnsKey; }
        protected getDialogType() { return WhatsAppTemplatesDialog; }
        protected getIdProperty() { return WhatsAppTemplatesRow.idProperty; }
        protected getInsertPermission() { return WhatsAppTemplatesRow.insertPermission; }
        protected getLocalTextPrefix() { return WhatsAppTemplatesRow.localTextPrefix; }
        protected getService() { return WhatsAppTemplatesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}